import React from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import { BackButton } from '../../components/ui/Button';
import { OptionCard, TipBox, PageHeader } from '../../components/ui';

const contentOptions = [
  {
    id: 'idea',
    icon: 'mdi:lightbulb',
    iconColor: '#F59E0B',
    iconBgColor: '#FEF3C7',
    title: 'Start from Ideas',
    subtitle: 'Idea to Post',
    description: 'Enter your ideas or topics, AI helps you brainstorm and generate complete posts',
    path: '/templates/content-generator/idea'
  },
  {
    id: 'threads',
    icon: 'mdi:forum-outline',
    iconColor: '#8B5CF6',
    iconBgColor: '#EDE9FE',
    title: 'Threads Reference',
    subtitle: 'Keyword Search',
    description: 'Find trending Threads posts to inspire your content creation',
    path: '/templates/content-generator/threads'
  },
  {
    id: 'youtube',
    icon: 'mdi:youtube',
    iconColor: '#EF4444',
    iconBgColor: '#FEE2E2',
    title: 'YouTube to Post',
    subtitle: 'Video Transcript',
    description: 'Generate engaging posts from YouTube video transcripts',
    path: '/templates/content-generator/youtube'
  },
  {
    id: 'google-trends',
    icon: 'mdi:trending-up',
    iconColor: '#10B981',
    iconBgColor: '#D1FAE5',
    title: 'Trending Topics',
    subtitle: 'Google Trends',
    description: 'Create timely content based on current trending topics',
    path: '/templates/content-generator/google-trends',
    comingSoon: true
  }
];

function ContentGeneratorSelect() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[var(--bg-primary)] text-[var(--text-primary)]">
      <div className="flex h-screen">
        <Sidebar activePage="home" />

        <div className="flex-1 overflow-y-auto bg-gray-50">
          {/* Back Button */}
          <BackButton
            onClick={() => navigate('/home')}
            className="fixed top-6 left-[280px] z-[100]"
          >
            Back to Home
          </BackButton>

          <div className="max-w-[900px] mx-auto px-8 py-16">
            {/* Header */}
            <PageHeader
              badge="Content Generator"
              badgeIcon="mdi:image-multiple"
              title="Choose Your Source"
              subtitle="Select an inspiration source to create carousel posts or text content"
            />

            {/* Options Grid */}
            <div className="grid grid-cols-[repeat(auto-fit,minmax(280px,1fr))] gap-4">
              {contentOptions.map((option) => (
                <OptionCard
                  key={option.id}
                  icon={option.icon}
                  iconColor={option.iconColor}
                  iconBgColor={option.iconBgColor}
                  title={option.title}
                  subtitle={option.subtitle}
                  description={option.description}
                  comingSoon={option.comingSoon}
                  onClick={() => navigate(option.path)}
                />
              ))}
            </div>

            {/* Quick Tips */}
            <TipBox className="mt-8">
              Choose your content source, then customize the design and generate carousel images or text posts.
              All generated content can be published directly to Threads or saved as drafts.
            </TipBox>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContentGeneratorSelect;
